/**
 * Load golden App JSON for hybrid public demos (CLAW Form→Flow→App).
 */
import returnApp from '../../../packages/builder-schema/fixtures/golden-exports/IF-return-assistant-v1.app.json';
import personalApp from '../../../packages/builder-schema/fixtures/golden-exports/IF-personal-assistant-v1.app.json';
import deskApp from '../../../packages/builder-schema/fixtures/golden-exports/IF-desk-agent-v1.app.json';
import homeSearchApp from '../../../packages/builder-schema/fixtures/golden-exports/IF-home-search-advisor-v1.app.json';
import listingApp from '../../../packages/builder-schema/fixtures/golden-exports/IF-listing-agent-v1.app.json';
import recruitingApp from '../../../packages/builder-schema/fixtures/golden-exports/IF-recruiting-advisor-v1.app.json';

function withPublicId(def, id) {
  return {
    ...def,
    id,
    metadata: {
      ...(def.metadata || {}),
      interviewFlow: {
        ...(def.metadata?.interviewFlow || {}),
        citizenMode: true,
        publicAdvise: true,
      },
    },
  };
}

export const DEMO_ASSISTANT_META = {
  recruiting: {
    path: '/v2/demo/recruiting',
    title: 'Hiring screening portal',
    subtitle: 'Rubric scorecard, risk flags, interview plan, pipeline',
    primaryColor: '#14532d',
    helpPath: '/studio/help/recruiting',
    definition: withPublicId(recruitingApp, 'if-recruiting-advisor-demo'),
  },
  returns: {
    path: '/v2/demo/returns',
    title: 'Returns portal',
    subtitle: 'Policy matrix, exchanges, labels, exception queue',
    primaryColor: '#0f766e',
    helpPath: '/studio/help/returns',
    definition: withPublicId(returnApp, 'if-return-assistant-demo'),
  },
  personal: {
    path: '/v2/demo/personal',
    title: 'Personal assistant',
    subtitle: 'Email, meeting prep, task triage, day brief',
    primaryColor: '#1e3a5f',
    helpPath: '/studio/help/personal-assistant',
    definition: withPublicId(personalApp, 'if-personal-assistant-demo'),
  },
  desk: {
    path: '/v2/demo/desk',
    title: 'Desk Continuum',
    subtitle: 'Arrive → Triage → Focus → Ship → Close on your machine',
    primaryColor: '#0f766e',
    helpPath: '/studio/help/desk-agent',
    definition: withPublicId(deskApp, 'if-desk-agent-demo'),
  },
  realestate: {
    path: '/v2/demo/realestate',
    title: 'Home search advisor',
    subtitle: 'Affordability + shortlist + buyer briefing',
    primaryColor: '#2e7d32',
    helpPath: '/studio/help/home-search',
    definition: withPublicId(homeSearchApp, 'if-home-search-demo'),
  },
  listings: {
    path: '/v2/demo/listings',
    title: 'Listing agent pipeline',
    subtitle: 'Discover → triage → enrich → campaign blast',
    primaryColor: '#0277bd',
    helpPath: '/studio/help/listing-agent',
    definition: withPublicId(listingApp, 'if-listing-agent-demo'),
  },
};

export function getDemoAssistant(key) {
  return DEMO_ASSISTANT_META[key] || null;
}
